import React, { useEffect } from "react";
import { RCCAlert, RCCButton, RCCGrid, RCCIcon, RCCTooltip } from "react-common-components";
import { useFieldArray } from "react-hook-form";
import LovStrategies from "src/components/Lov/Strategies";
import Title from "src/components/Title";
import { useTranslation } from "src/context/Translations/context";

import { IComponentstrategies } from "./interface";

const Strategies: React.FC<IComponentstrategies> = ({
	control,
	error,
	strategiesDefaultValue,  
	disabled,
	register,
	clearErrors
}) => {
	const { translate } = useTranslation();

	const { 
		fields: fieldsStrategies, 
		remove: removeStrategies,
		append: appendStrategies
	} = useFieldArray({
		control,
		name: "prtba006",
		shouldUnregister: true
	});

	const addStrategy = () => {
		clearErrors("prtba006");
		const strategy: any = {};
		strategy.pra006Id = "0";
		strategy.pra006Mee001Id = "";
		appendStrategies(strategy);
	};


	useEffect(() => {
		appendStrategies(strategiesDefaultValue ?? []);
	}, []);

	const defaultValueLovStrategies = (strategy: any) => {
		if(strategy.pra006Mee001Id && strategy.mee001Titulo)
			return { value: String(strategy.pra006Mee001Id), label: strategy.mee001Titulo };
		if(strategy.pra006Mee001Id)	
			return String(strategy.pra006Mee001Id);
		return undefined;
	};

	return (
		<>
			<RCCGrid
				container
				item
				direction="column"
				alignItems="center"
				justifyContent="center"
			>
				<RCCGrid
					container
					item
					xs={12}
					sm={12}
					md={8}
					lg={8}
				>
					<RCCGrid
						container
						item
					>
						<RCCGrid
							container
							item
							justifyContent="flex-end"
						>
							<RCCTooltip
								color="purple"
								text={translate("Adicionar estratégia")}
							>
								<RCCButton
									color="purple"
									icon={{
										name: "plus"
									}}
									layout="isRounded"
									size="md"
									onClick={addStrategy}
									disabled={disabled}
								/>
							</RCCTooltip>
						</RCCGrid>
					</RCCGrid>
								
					<RCCGrid
						container
						item
					>
						{error.prtba006 && error.prtba006.message && (
							<Title color="red" size="xs">
								<RCCIcon
									name="infoCircle"
									color="var(--red)"
									style={{ marginRight: "8px"}}
								/>
								{error.prtba006.message}
							</Title>
						)}
						{fieldsStrategies.length === 0 && (
							<RCCAlert
								color="grey"
								title={translate("Nenhuma estratégia vinculada")}
								description={translate("Aperte no botão acima para adicionar")}
							/>
						)}
						{fieldsStrategies.map((premise: any, index: number) => (
							<RCCGrid
								container
								item
								direction="column"
								alignContent="center"
								key={premise.id}
							>
								<RCCGrid
									container
									item
									alignItems="flex-end"
								>
									<input 
										type="text"
										value={premise.pra006Id}
										{...register(`prtba006[${index}].pra006Id`)} 
										style={{ display: "none" }} 
										readOnly
									/>
									<RCCGrid
										container
										item
										justifyContent="center"
										xs={12}
										sm={11}
										styleInline="textarea{ height: 100px }"
									>
										<LovStrategies 
											control={control}
											name={`prtba006[${index}].pra006Mee001Id`}
											label=""
											defaultValue={defaultValueLovStrategies(premise)}
											error={error.prtba006 && error.prtba006[index]?.pra006Mee001Id}
											disabled={disabled}
											onChangeCapture={() => clearErrors("prtba006")}	
											isCreatable={false}
											styleInline="margin: 0px;"
										/>
									</RCCGrid>
									<RCCGrid
										container
										item
										justifyContent="flex-end"
										xs={12}
										sm={1}
									>
										<RCCTooltip
											color="red"
											text={translate("Excluir")}
										>
											<RCCButton
												color="transparent"
												icon={{
													name: "trash",
													color: "var(--red)"
												}}
												layout="isRounded"
												onClick={() => {
													clearErrors("prtba006");
													removeStrategies(index);
												}}
												disabled={disabled}
											/>
										</RCCTooltip>
									</RCCGrid>
								</RCCGrid>
							</RCCGrid>										
						))}
					</RCCGrid>
				</RCCGrid>
			</RCCGrid>
		</>
	);
};

export default Strategies;
